module.exports = __webpack_public_path__ + "static/media/dashboard-games.dc279379.jpg";